import { render, staticRenderFns } from "./CLoader.vue?vue&type=template&id=736380bc&"
import script from "./CLoader.vue?vue&type=script&lang=js&"
export * from "./CLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports